/* §285（2026-10-08）商品リストの横並びの棚：Horizon の slideshow.js が画面の外のスライドに
   aria-hidden="true" を付けるが、中のリンクやボタンは Tab でたどれるまま（4.2.0 でも同じ）。
   隠れたスライドの中だけ tabindex="-1" にして Tab で飛ばす。inert は使わない（端が見えている
   スライドもタップできるまま残すため）。aria-hidden の付け外しと、区画の書き換えに追従する。
   付ける属性は tabindex と控えの data 属性だけで、見張る属性（aria-hidden）とは別＝自分の書き換えで再発火しない。 */
(() => {
  const SLIDE_SELECTOR = '.resource-list__carousel slideshow-slide';
  const FOCUSABLE_SELECTOR = [
    'a[href]', 'area[href]', 'button', 'input:not([type="hidden"])', 'select', 'textarea',
    'iframe', 'summary', '[tabindex]', '[contenteditable=""]', '[contenteditable="true"]',
  ].join(',');
  /* 元の tabindex の控え（元が無い時は空文字） */
  const SAVED = 'data-igniere-tabindex';

  const lockSlide = (slide) => {
    for (const el of slide.querySelectorAll(FOCUSABLE_SELECTOR)) {
      if (el.hasAttribute(SAVED)) continue;
      el.setAttribute(SAVED, el.getAttribute('tabindex') ?? '');
      el.setAttribute('tabindex', '-1');
    }
  };

  const unlockSlide = (slide) => {
    for (const el of slide.querySelectorAll(`[${SAVED}]`)) {
      const previous = el.getAttribute(SAVED);
      el.removeAttribute(SAVED);
      if (previous) el.setAttribute('tabindex', previous);
      else el.removeAttribute('tabindex');
    }
  };

  const syncSlide = (slide) => {
    if (slide.getAttribute('aria-hidden') === 'true') lockSlide(slide);
    else unlockSlide(slide);
  };

  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') {
        if (record.target instanceof Element && record.target.matches(SLIDE_SELECTOR)) syncSlide(record.target);
        continue;
      }
      /* 区画の再描画やカードの差し替えで足された要素にも当てる */
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        const slide = node.closest(SLIDE_SELECTOR);
        if (slide) syncSlide(slide);
        else node.querySelectorAll(SLIDE_SELECTOR).forEach(syncSlide);
      }
    }
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden'] });

  document.querySelectorAll(SLIDE_SELECTOR).forEach(syncSlide);
})();
